<template>
<div id="pageOrder">
    <v-container grid-list-xl fluid>
        <v-layout row wrap class="page-header-right">
            <!-- Summary info -->
            <v-flex lg6 pa-0 pl-3 pt-3 class="d-flex align-center">
                <span class="mr-3 font-weight-bold subtitle-1 text-slate-800">Mã đơn: MD{{ orderId }}</span>
                <v-btn
                    :color="order.Status | order_status_color"
                    width="160px"
                    height="36px"
                    small
                    dark
                    depressed
                    outlined
                  >{{ order.Status | order_status}}</v-btn>
                <v-chip
                    v-if="order.OrderType === 'NKCN'"
                    :color="order.IsProcessedCN === true || order.IsProcessedCN === 1 ? 'green' : 'red'"
                    class="ml-2"
                    small
                    label
                    dark
                >
                    {{ (order.IsProcessedCN === true || order.IsProcessedCN === 1) ? 'Đã xử lý CN' : 'Chưa xử lý CN' }}
                </v-chip>
            </v-flex>
            <!-- Action buttons -->
            <v-flex lg6 pa-0 pr-6 pt-6>
                <v-layout row wrap justify-end>
                    <v-btn @click="WaitPayOrder" v-if="order.Status == statusEnum.cho_bao_gia && (purchaseRole || adminRole)" color="red" dark>
                        Chờ đặt cọc
                    </v-btn>
                    <v-btn @click="backAmountVND = order.Deposit; dialogCancelOrder = true" v-if="(orderReady && (orderRole & 2048)) || adminRole || !canReorder" color="black" dark>
                        Hủy đơn
                    </v-btn>
                    <v-btn @click="ReOrder" v-if="canReorder">
                        Lên đơn
                    </v-btn>
                     <v-btn @click="DepositOrder" v-if="order.Status == statusEnum.cho_dat_coc && (purchaseRole || saleRole || adminRole || csRole)" color="red" dark>
                        Đặt cọc
                     </v-btn>
                     <v-btn @click="SendAccountant" v-if="order.Status == statusEnum.da_dat_coc && (purchaseRole || adminRole)" color="success" dark>
                        Chuyển Kế Toán
                     </v-btn>
                     <v-btn @click="SendPurchase" v-if="(order.Status == statusEnum.cho_mua_hang || order.Status == statusEnum.cho_tt_lan_2) && (paymentRole || adminRole)" color="red" dark>
                        Chuyển Mua Hàng
                     </v-btn>
                     <v-btn @click="WaitPayment2Order" v-if="order.Status == statusEnum.cho_mua_hang && (paymentRole || adminRole)" color="warning" dark>
                        Chờ TT lần 2
                     </v-btn>
                     <v-btn @click="BuyOrder" v-if="(order.Status == statusEnum.cho_mua_hang || order.Status == statusEnum.cho_tt_lan_2) && (paymentRole || adminRole)" color="success" dark>
                        Đã mua hàng
                     </v-btn>
                    <v-btn @click="RevertOrder" v-if="order.Status == statusEnum.hoan_thanh && adminRole">
                        Xuất kho
                    </v-btn>
                    <v-btn @click="CompleteOrder" v-if="canCompleteOrder">
                        Hoàn thành
                    </v-btn>
                    <v-chip
                        v-if="orderHasPendingComplain"
                        color="error"
                        text-color="white"
                        small
                        label
                        class="mr-2 font-weight-bold"
                    >
                        <v-icon x-small left>fa-exclamation-triangle</v-icon>
                        Đang có khiếu nại chưa xử lý
                    </v-chip>
                    <order-flag-menu :orderID="orderId"></order-flag-menu>
                    <!-- <order-widget-menu></order-widget-menu> -->
                </v-layout>
            </v-flex>
            <v-flex xs12 pa-0 class="mx-4 mt-2" v-if="checkedFlags.length > 0">
                <div class="order-short-tags">
                    <v-chip
                        v-for="item in checkedFlags"
                        :key="item.FlagID"
                        small
                        label
                        light
                        class="mr-2 mb-2"
                        :color="item.FlagColor"
                    >
                        {{ item.ShortTag }}
                    </v-chip>
                </div>
            </v-flex>
            <!-- Summary Banner Grid -->
            <v-flex xs12 pa-0 class="mt-3 mb-2 mx-4">
                <v-layout row wrap>
                    <!-- Card 1: Khách hàng -->
                    <v-flex xs12 sm6 md3 class="pa-2">
                        <v-card outlined class="pa-3 rounded-lg bg-blue-gradient border elevation-0">
                            <div class="d-flex align-center">
                                <div class="pa-3 bg-blue-50 text-blue-600 rounded-lg mr-3">
                                    <v-icon color="primary" small>fas fa-user-circle</v-icon>
                                </div>
                                <div>
                                    <div class="caption text-slate-400 font-weight-bold text-uppercase">Khách hàng</div>
                                    <div class="body-2 font-weight-bold text-slate-800"><a :href="`/khach-hang/quan-ly-khach-hang/${customer.ID}`" target="_blank" class="text-decoration-none text-slate-800 hover:primary transition-colors">{{ customer.Username }}</a></div>
                                    <div class="caption text-slate-400 font-mono">#{{ customer.ID }}</div>
                                </div>
                            </div>
                        </v-card>
                    </v-flex>
                    <!-- Card 2: Trọng lượng / Thể tích -->
                    <v-flex xs12 sm6 md3 class="pa-2">
                        <v-card outlined class="pa-3 rounded-lg bg-teal-gradient border elevation-0">
                            <div class="d-flex align-center">
                                <div class="pa-3 bg-teal-50 text-teal-600 rounded-lg mr-3">
                                    <v-icon color="teal" small>fas fa-balance-scale</v-icon>
                                </div>
                                <div>
                                    <div class="caption text-slate-400 font-weight-bold text-uppercase">Trọng lượng / Thể tích</div>
                                    <div class="body-2 font-weight-bold text-slate-800">{{ order.OrderWeight || 0 }} {{ order.FeeShipType == 1 ? 'm3' : 'kg' }}</div>
                                </div>
                            </div>
                        </v-card>
                    </v-flex>
                    <!-- Card 3: Tổng giá trị đơn -->
                    <v-flex xs12 sm6 md3 class="pa-2">
                        <v-card outlined class="pa-3 rounded-lg bg-purple-gradient border elevation-0">
                            <div class="d-flex align-center">
                                <div class="pa-3 bg-violet-50 text-violet-600 rounded-lg mr-3">
                                    <v-icon color="purple" small>fas fa-calculator</v-icon>
                                </div>
                                <div>
                                    <div class="caption text-slate-400 font-weight-bold text-uppercase">Tổng giá trị đơn</div>
                                    <div class="body-2 font-weight-bold primary--text">{{ order.TotalAmountVND | currency }}</div>
                                    <div class="caption green--text font-weight-bold">Đã cọc: {{ orderEditable.Deposit | currency }}</div>
                                </div>
                            </div>
                        </v-card>
                    </v-flex>
                    <!-- Card 4: Ngày khởi tạo -->
                    <v-flex xs12 sm6 md3 class="pa-2">
                        <v-card outlined class="pa-3 rounded-lg bg-amber-gradient border elevation-0">
                            <div class="d-flex align-center">
                                <div class="pa-3 bg-amber-50 text-amber-600 rounded-lg mr-3">
                                    <v-icon color="orange" small>fas fa-clock</v-icon>
                                </div>
                                <div>
                                    <div class="caption text-slate-400 font-weight-bold text-uppercase">Ngày khởi tạo</div>
                                    <div class="body-2 font-weight-bold text-slate-800">{{ order.CreatedDate | display_date('DD-MM-YYYY HH:mm') }}</div>
                                    <div class="caption text-slate-500">Bởi CSKH/Saler</div>
                                </div>
                            </div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>

            <!-- Dynamic Tabs Wrapper -->
            <v-flex xs12 pa-0 class="mt-2 mx-4">
                <v-card class="elevation-1 rounded-lg">
                    <v-tabs v-model="selectedTab" background-color="blue-grey lighten-5" color="primary" slider-color="primary" show-arrows>
                        <v-tab v-if="showOverviewTab" href="#general">
                            <v-icon left small color="blue">fas fa-info-circle</v-icon>
                            Tổng quan
                        </v-tab>
                        <v-tab v-if="showTransactionTab" href="#transaction">
                            <v-icon left small color="teal">fas fa-barcode</v-icon>
                            Mã vận đơn
                        </v-tab>

                        <v-tab v-if="orderWidgets.paymentHistory" href="#payment-history">
                            <v-icon left small color="deep-purple">fas fa-history</v-icon>
                            Lịch sử thanh toán
                        </v-tab>
                        <v-tab v-if="orderWidgets.complain" href="#complain-history">
                            <v-icon left small color="error">fas fa-exclamation-circle</v-icon>
                            Lịch sử khiếu nại
                        </v-tab>
                        <v-tab v-if="orderWidgets.changeHistory" href="#change-history">
                            <v-icon left small color="orange">fas fa-history</v-icon>
                            Lịch sử thay đổi
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="selectedTab">
                        <v-tab-item value="general" v-slot:default v-if="showOverviewTab" class="pa-4">
                            <div class="overview-stack">
                                <div class="overview-section">
                                    <tab-general-info
                                      :order="order"
                                      :customer="customer"
                                      :order-editable="orderEditable"
                                      :order-role="orderRole"
                                      :order-readonly="orderReadonly"
                                      :admin-role="adminRole"
                                      :store-role="storeRole"
                                      :cs_staffs="cs_staffs"
                                      :p_staffs="p_staffs"
                                      :sale_staffs="sale_staffs"
                                      :xnk_staffs="xnk_staffs"
                                      :china-stores="chinaStores"
                                      :warehouses="warehouses"
                                      :list_product_types="list_product_types"
                                    ></tab-general-info>
                                </div>

                                <div v-if="orderWidgets.product && (orderRole & 4)" class="overview-section">
                                    <div class="overview-section__header">
                                        <div>
                                            <div class="overview-section__eyebrow">Giao dịch hàng hóa</div>
                                            <div class="overview-section__title">Sản phẩm</div>
                                        </div>
                                        <div class="overview-section__meta">
                                            {{ products ? products.length : 0 }} sản phẩm
                                        </div>
                                    </div>
                                    <tab-products
                                      :order="order"
                                      :order-editable="orderEditable"
                                      :products="products"
                                      :product-editable="productEditable"
                                      :order-edit-role="orderEditRole"
                                      :order-readonly="orderReadonly"
                                      :admin-role="adminRole"
                                      :order-role="orderRole"
                                      :complain-role="complainRole"
                                      :cs-role="csRole"
                                      :internal-role="internalRole"
                                      :real-amount-role="realAmountRole"
                                      :editable-role="editableRole"
                                      :sale-role="saleRole"
                                      :total-product="totalProduct"
                                      :fee-ship-cny.sync="feeShipCNY"
                                      :total-real-amount-cny.sync="totalRealAmountCNY"
                                      :require-real-money="requireRealMoney"
                                      :product-header="productHeader"
                                      @remove-product="removeProduct"
                                      @refresh="refreshData"
                                      @manual-update="manualUpdateDetail"
                                    ></tab-products>
                                </div>

                                <div v-if="orderWidgets.complain" class="overview-section">
                                    <div class="overview-section__header">
                                        <div>
                                            <div class="overview-section__eyebrow">Chứng từ và hải quan</div>
                                            <div class="overview-section__title">Khai báo</div>
                                        </div>
                                    </div>
                                    <tab-declarations
                                      :order="order"
                                      :order-editable="orderEditable"
                                      :order-readonly="orderReadonly"
                                      :admin-role="adminRole"
                                      :internal-role="internalRole"
                                      :order-role="orderRole"
                                      :declaration-header="declarationHeader"
                                      :declaration_status_list="declaration_status_list"
                                    ></tab-declarations>
                                </div>

                                <div v-if="orderWidgets.paymentArea && (orderRole & 256) && !storeRole" class="overview-section">
                                    <div class="overview-section__header">
                                        <div>
                                            <div class="overview-section__eyebrow">Chi phí và thanh toán</div>
                                            <div class="overview-section__title">Tài chính</div>
                                        </div>
                                    </div>
                                    <tab-finance
                                      :order="order"
                                      :order-editable="orderEditable"
                                      :order-readonly="orderReadonly"
                                      :status-enum="statusEnum"
                                      :admin-role="adminRole"
                                      :payment-role="paymentRole"
                                      :purchase-role="purchaseRole"
                                      :guarantees="guarantees"
                                    ></tab-finance>
                                </div>
                            </div>
                        </v-tab-item>

                        <v-tab-item value="transaction" v-slot:default v-if="showTransactionTab" class="pa-4">
                            <tab-transactions
                              :order="order"
                              :customer="customer"
                              :order-id="orderId"
                              :order-locked="orderLocked"
                              :confirm-price="confirmPrice"
                              :total-real-amount-cny="totalRealAmountCNY"
                              :order-not-deposit="orderNotDeposit"
                              :order-readonly="orderReadonly"
                              :order-edit-role="orderEditRole"
                            ></tab-transactions>
                        </v-tab-item>


                        <v-tab-item value="payment-history" v-slot:default v-if="orderWidgets.paymentHistory" class="pa-4">
                            <tab-payment-history
                              :order="order"
                              :payment-history-header="paymentHistoryHeader"
                              :can-pay="adminRole || paymentRole"
                              @refresh-order="refreshData"
                            ></tab-payment-history>
                        </v-tab-item>

                        <v-tab-item value="complain-history" v-slot:default v-if="orderWidgets.complain" class="pa-4">
                            <tab-complain-history
                              :order="order"
                              :payment-complain-header="paymentComplainHeader"
                              :complain-role="complainRole"
                            ></tab-complain-history>
                        </v-tab-item>

                        <v-tab-item value="change-history" v-slot:default v-if="orderWidgets.changeHistory" class="pa-4">
                            <tab-change-history
                              :order="order"
                              :changed-history-header="changedHistoryHeader"
                            ></tab-change-history>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-flex>
        </v-layout>

        <v-dialog v-model="dialogCancelOrder" max-width="300px">
            <v-card>
                <v-card-title>
                <span class="title">Xác nhận hủy đơn hàng</span>
                </v-card-title>
                <v-card-text>
                <v-container grid-list-md pa-0>
                    <v-layout row wrap>
                    <v-flex lg12>
                        <h-currency-input :disabled="order.Status == statusEnum.da_dat_coc || order.Status == statusEnum.cho_dat_coc || order.Status == statusEnum.cho_bao_gia" label="Tiền hoàn khách" v-model="backAmountVND" :decimal="0"></h-currency-input>
                    </v-flex>
                    </v-layout>
                </v-container>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1 white--text" @click="dialogCancelOrder = false">Đóng</v-btn>
                <v-btn color="red darken-1 white--text" @click="CancelOrder">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</div>
</template>

<script>
import OrderFlag from "@/components/widgets/OrderFlag";
import TabGeneralInfo from "./TabGeneralInfo.vue";
import TabProducts from "./TabProducts.vue";
import TabTransactions from "./TabTransactions.vue";
import TabDeclarations from "./TabDeclarations.vue";
import TabFinance from "./TabFinance.vue";

import TabPaymentHistory from "./TabPaymentHistory.vue";
import TabComplainHistory from "./TabComplainHistory.vue";
import TabChangeHistory from "./TabChangeHistory.vue";
import { sendErrorNotice, sendSuccessNotice } from "@/commons/utils";
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import {
    payment_type,
    payment_type_color,
    complain_type,
    complain_type_color
} from "@/commons/hpod";

const OVERVIEW_TAB = "general";
const legacyTabMap = {
    product: OVERVIEW_TAB,
    declaration: OVERVIEW_TAB,
    finance: OVERVIEW_TAB
};

function normalizeTab(tab) {
    if (!tab) return OVERVIEW_TAB;
    return legacyTabMap[tab] || tab;
}

export default {
    filters: {
        payment_type,
        payment_type_color,
        complain_type,
        complain_type_color,
        payment_method: function (value) {
            return value == 1 ? "Trực tiếp" : "Ví điện tử";
        },
    },
    components: {
        'order-flag-menu': OrderFlag,
        TabGeneralInfo,
        TabProducts,
        TabTransactions,
        TabDeclarations,
        TabFinance,

        TabPaymentHistory,
        TabComplainHistory,
        TabChangeHistory
    },
    data() {
        return {
            selectedTab: normalizeTab(this.$route.query.tab),
            ignoreUpdate: false,
            statusEnum: configs.ORDER_STATUS_ENUM,
            tempOrder: {},
            showCustomerDetail: false,
            dialogCancelOrder: false,
            backAmountVND: 0,
            feeShipCNY: 0,
            totalRealAmountCNY: 0,
            payment_status: configs.PAYMENT_STATUS_LIST,
            declaration_status_list: configs.DECLARE_STATUS_LIST,
            requireRealMoney: [
                v => parseFloat(v.replace(/[^\d\.\-]/g, "")) > 0 || this.order.Status == this.statusEnum.cho_bao_gia || this.order.Status == this.statusEnum.cho_dat_coc  || this.order.Status == this.statusEnum.da_dat_coc || this.order.Status == this.statusEnum.huy || "Trường dữ liệu không được để trống.",
                v => parseFloat(v.replace(/[^\d\.\-]/g, "")) <= (this.order.AmountCNY + this.order.FeeShipCN).toFixed(2) || 'Tiền mua thật không được lớn hơn tổng giá sản phẩm'
            ],
            orderEditable: {
                Note: '',
                OrderID: 0,
                SalerID: 0,
                CustomerServiceID: 0,
                BuyerID: 0,
                XNKID: 0,
                AmountCNY: 0,
                AmountVND: 0,
                ExchangeRate: 0,
                ExchangeRateBuy: 0,
                TotalRealAmountCNY: 0,
                FeeShipCN: 0,
                FeeShipCNVND: 0,
                FeeBuy: 0,
                FeeBuyDiscount: 0,
                FeeWeight: 0,
                FeeWeightDiscount: 0,
                FeeOther: 0,
                FeeOtherNote: '',
                ChinaStoreID: 0,
                ReceivePlaceID: 0,
                IsFragileGoods: false,
                FragileFee: 0,
                FragileFeeVND: 0,
                IsCheck: false,
                CheckFeeType: 0,
                CheckFee: 0,
                CheckFeeVND: 0,
                IsFast: false,
                FastFee: 0,
                FastFeeVND: 0,
                GuaranteeType: 0,
                Deposit: 0,
                MinDeposit: 0,
                MinDepositFixed: 0,
                DiscountVND: 0,
                MinDepositRequest: null,
                WeChatId: null,
                IsUpdateFeeShip: 0,
                BackAmountVND: 0,
                CostWeight: 0,
                ProductType: 0,
                OrderType: 'NKCN',
                CommissionFeeVND: 0,
                FeeUTNK: 0,
                FeeUTNKFix: 0,
                Surcharge1Amount: 0,
                Surcharge1Note: '',
                Surcharge1CostAmount: 0,
                Surcharge2Amount: 0,
                Surcharge2Note: '',
                Surcharge2CostAmount: 0,
                CostUTNK: 0,
                TotalInvoicePrice: 0,
                TaxOtherRate: 0,
                TaxOtherAmount: 0,
                TaxOtherNote: '',
                TaxNKRate: 0,
                TaxNKAmount: 0,
                TaxNKNote: '',
                TaxVATRate: 0,
                TaxVATAmount: 0,
                TaxVATNote: ''
            },
            paymentHistoryHeader: [{
                    text: "Ngày thanh toán",
                    value: "CreatedDate",
                    sortable: false
                },
                {
                    text: "Loại thanh toán",
                    value: "Status",
                    sortable: false
                },
                {
                    text: "Hình thức thanh toán",
                    value: "Type",
                    sortable: false
                },
                {
                    text: "Nội dung",
                    value: "Note",
                    sortable: false
                },
                {
                    text: "Số tiền",
                    value: "Amount",
                    sortable: false,
                    align: "end"
                }
            ],
            changedHistoryHeader: [{
                    text: "Ngày thay đổi",
                    value: "CreatedDate",
                    sortable: false
                },
                {
                    text: "Người thay đổi",
                    value: "Username",
                    sortable: false
                },
                {
                    text: "Nội dung",
                    value: "HistoryContent",
                    sortable: false
                }
            ],
            declarationHeader: [{
                    text: "ID",
                    value: "ID",
                    sortable: false
                },
                {
                    text: "Mã KB",
                    value: "MaKB",
                    sortable: false
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    sortable: false
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    sortable: false
                },
                {
                    text: "Thao tác",
                    align: "center",
                    value: "",
                    sortable: false
                }
            ],
            paymentComplainHeader: [{
                    text: "ID",
                    value: "ID",
                    sortable: false
                },
                {
                    text: "Số tiền",
                    value: "Amount",
                    sortable: false,
                    align: "end"
                },
                {
                    text: "Nội dung",
                    value: "ComplainText",
                    sortable: false
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    sortable: false
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    sortable: false
                },
                {
                    text: "Thao tác",
                    align: "center",
                    value: "",
                    sortable: false
                }
            ],
            productHeader: [{
                    text: "TT",
                    value: "index",
                    sortable: false
                },
                {
                    text: "SP",
                    value: "title_origin",
                    sortable: false
                },
                {
                    text: "Ảnh",
                    value: "image_origin",
                    sortable: false
                },
                {
                    text: "Thuộc tính",
                    value: "property",
                    sortable: false
                },
                {
                    text: "Số lượng",
                    value: "quantity",
                    align: "end",
                    sortable: false
                },
                {
                    text: "Giá (¥)",
                    value: "price_promotion",
                    align: "end",
                    sortable: false
                },
                {
                    text: "Thành tiền (¥)",
                    value: "total",
                    align: "end",
                    sortable: false
                },
                {
                    text: "",
                    align: "center",
                    sortable: false,
                    width: '120px'
                }
            ]
        };
    },
    computed: {
        orderId() {
            return Number(this.$route.params.Pid);
        },
        orderStatus() {
            return configs.ORDER_STATUS;
        },
        totalProduct() {
            return _.sumBy(this.products, 'quantity');
        },
        customerView() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Manager) == configs.ROLE_TYPE.Manager);
        },
        canReorder() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.huy;
        },
        orderReady() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.da_dat_coc;
        },
        orderPaymentReady() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.da_nhap_kho_vn;
        },
        orderNotDeposit() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.cho_dat_coc;
        },
        orderLocked() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.huy || this.order.Status == configs.ORDER_STATUS_ENUM.khieu_nai;
        },
        confirmPrice() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.cho_bao_gia;
        },
        orderReadonly() {
            const isBaseReadonly = this.order.Status == configs.ORDER_STATUS_ENUM.huy || this.order.Status == configs.ORDER_STATUS_ENUM.hoan_thanh || this.order.Status == configs.ORDER_STATUS_ENUM.khieu_nai;
            const isSaleLocked = this.saleRole && (this.order.Status !== configs.ORDER_STATUS_ENUM.cho_bao_gia && this.order.Status !== configs.ORDER_STATUS_ENUM.cho_dat_coc);
            return isBaseReadonly || isSaleLocked;
        },
        orderPaidFull() {
            if (!this.order) return false;
            const total = Number(this.order.TotalAmountVND || 0);
            const deposit = Number((this.orderEditable && this.orderEditable.Deposit != null) ? this.orderEditable.Deposit : (this.order.Deposit || 0));
            return total > 0 && Math.round(deposit) >= Math.round(total);
        },
        orderHasPendingComplain() {
            if (!this.order || !this.order.OrderComplains || !this.order.OrderComplains.length) {
                return false;
            }
            return this.order.OrderComplains.some(c => ![0, 3, 4].includes(Number(c.Status)));
        },
        canCompleteOrder() {
            return Boolean(
                this.adminRole &&
                this.order &&
                this.order.Status != this.statusEnum.hoan_thanh &&
                this.orderPaidFull &&
                !this.orderHasPendingComplain
            );
        },
        orderRole() {
            return this.$store.state.authentication.role.Orders;
        },
        orderEditRole() {
            return this.$store.state.authentication.role.OrderEditable;
        },
        productEditable() {
            return this.order.Status == configs.ORDER_STATUS_ENUM.da_dat_coc || this.order.Status == configs.ORDER_STATUS_ENUM.cho_dat_coc || this.order.Status == configs.ORDER_STATUS_ENUM.cho_bao_gia  || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.InteralControl) == configs.ROLE_TYPE.InteralControl);
        },
        complainRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase);
        },
        realAmountRole() {
            return this.adminRole || this.paymentRole || this.purchaseRole;
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        storeRole() {
            return this.$store.state.authentication.user.roletype == configs.ROLE_TYPE.StoreVN || this.$store.state.authentication.user.roletype == configs.ROLE_TYPE.StoreTQ;
        },
        purchaseRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
        },
        paymentRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
        },
        csRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
        },
        saleRole() {
            if (this.adminRole) return false;
            const user = this.$store.state.authentication.user || {};
            const roleType = Number(user.roletype || user.RoleType || 0);
            return (roleType & configs.ROLE_TYPE.Sale) === configs.ROLE_TYPE.Sale || Number(user.IsSaleLeader || 0) === 1;
        },
        internalRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.InteralControl) == configs.ROLE_TYPE.InteralControl;
        },
        editableRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase) || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.InteralControl) == configs.ROLE_TYPE.InteralControl);
        },
        ...mapState({
            order: state => state.main_order.selectedOrder,
            customer: state => state.main_order.selectedOrder.Customer,
            products: state => state.main_order.selectedOrder.Products,
            orderCodes: state => state.ordercn.all.data || [],
            staffs: state => state.commons.all_users,
            p_staffs: state =>
                _.filter(state.commons.all_users, function(o) {
                return (o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
            }),
            cs_staffs: state =>
                _.filter(state.commons.all_users, function(o) {
                return (o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
            }),
            sale_staffs: state => {
                let list = _.filter(state.commons.all_users, function(o) {
                    return (o.RoleType & configs.ROLE_TYPE.Sale) == configs.ROLE_TYPE.Sale;
                });
                const curId = state.main_order.selectedOrder ? state.main_order.selectedOrder.SalerID : null;
                if (curId && !list.some(u => u.ID === curId)) {
                    const found = (state.commons.all_users || []).find(u => u.ID === curId);
                    if (found) list = [found, ...list];
                }
                return list;
            },
            xnk_staffs: state => {
                let list = _.filter(state.commons.all_users, function(o) {
                    return (o.RoleType & configs.ROLE_TYPE.Officer) == configs.ROLE_TYPE.Officer;
                });
                const curId = state.main_order.selectedOrder ? (state.main_order.selectedOrder.XNKID || state.main_order.selectedOrder.OfficerID) : null;
                if (curId && !list.some(u => u.ID === curId)) {
                    const found = (state.commons.all_users || []).find(u => u.ID === curId);
                    if (found) list = [found, ...list];
                }
                return list;
            },
            vipLevels: state => state.customerLevel.all.data,
            warehouses: state => state.commons.stores,
            chinaStores: state => state.commons.chinaStores,
            allFlags: state => state.orderFlag.all.data,
            guarantees: state => {
                let tmp = [{PackageName: 'Không sử dụng', ID: 0}];
                if(state.feeGuarantee.all.data) {
                state.feeGuarantee.all.data.forEach(element => {
                    tmp.push(element);
                });
                }
                return tmp;
            },
            product_types: (state) => state.productType.all.data,
        }),
        ...mapState("main_order", {
            loading: "loading",
        }),
        ...mapState("commons", {
            orderWidgets: "orderWidgetSettings",
        }),
        ...mapState("orderTransaction", {
            weightEdited: "edited",
        }),
        checkedFlags() {
            return _.filter(this.allFlags || [], item => item.Checked && item.ShortTag);
        },
        list_product_types() {
            return this.product_types ? _.filter(this.product_types, (p) => { return !p.IsHidden}) : [];
        },
        showOverviewTab() {
            return this.orderWidgets.customer;
        },
        showTransactionTab() {
            return this.orderWidgets.transaction && (this.orderRole & 8);
        },

    },
    watch: {
        orderId() {
            this.refreshData();
        },
        weightEdited() {
            if (this.weightEdited) {
                this.refreshData();
            }
        },
        order() {
            this.ignoreUpdate = true;
            this.orderEditable = this.getOrderEditable();
            this.tempOrder = _.cloneDeep(this.orderEditable);
            this.feeShipCNY = this.order.FeeShipCN || 0;
            this.totalRealAmountCNY = this.order.TotalRealAmountCNY || 0;
            setTimeout(() => {
                this.ignoreUpdate = false;
            }, 1000);
        },
        orderEditable: {
            handler: function (newVal, oldVal) {
                if(!this.ignoreUpdate) {
                    this.updateOrderDetail(newVal, oldVal);
                }
            },
            deep: true,
            immediate: true
        },
        selectedTab(newVal) {
            if (newVal && this.$route.query.tab !== newVal) {
                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        tab: newVal
                    }
                }).catch(() => {});
            }
        },
        '$route.query.tab'(newVal) {
            this.selectedTab = normalizeTab(newVal);
        },
        'orderEditable.OrderType'(newVal) {
            if (newVal === 'NKTN') {
                this.orderEditable.FeeUTNK = 0;
                this.orderEditable.Surcharge1Amount = 0;
                this.orderEditable.Surcharge1CostAmount = 0;
                this.orderEditable.Surcharge2Amount = 0;
                this.orderEditable.Surcharge2CostAmount = 0;
                this.orderEditable.FeeUTNKFix = 0;
                this.orderEditable.CostUTNK = 0;
                this.orderEditable.TaxOtherRate = 0;
                this.orderEditable.TaxOtherAmount = 0;
                this.orderEditable.TaxNKRate = 0;
                this.orderEditable.TaxNKAmount = 0;
                this.orderEditable.TaxVATRate = 0;
                this.orderEditable.TaxVATAmount = 0;
                this.orderEditable.TotalInvoicePrice = 0;
            }
        }
    },
    methods: {
        getOrderEditable() {
            return {
                OrderID: this.order.ID,
                IsProcessedCN: this.order.IsProcessedCN,
                SalerID: this.order.SalerID,
                CustomerServiceID: this.order.CustomerServiceID,
                BuyerID: this.order.BuyerID,
                XNKID: this.order.XNKID || this.order.OfficerID || 0,
                TotalRealAmountCNY: this.order.TotalRealAmountCNY || 0,
                FeeShipCN: this.order.FeeShipCN,
                FeeShipCNVND: this.order.FeeShipCNVND,
                ExchangeRate: this.order.ExchangeRate,
                ExchangeRateBuy: this.order.ExchangeRateBuy || 0,
                FeeBuy: this.order.FeeBuy,
                FeeBuyDiscount: this.order.FeeBuyDiscount,
                FeeBuyAmount: this.order.FeeBuyAmount,
                FeeWeight: this.order.FeeWeight,
                FeeWeightDiscount: this.order.FeeWeightDiscount,
                FeeWeightAmount: this.order.FeeWeightAmount,
                FeeOther: this.order.FeeOther,
                FeeOtherNote: this.order.FeeOtherNote,
                ChinaStoreID: this.order.ChinaStoreID,
                ReceivePlaceID: this.order.ReceivePlaceID,
                IsFragileGoods: this.order.IsFragileGoods,
                FragileFee: this.order.FragileFee,
                FragileFeeVND: this.order.FragileFeeVND,
                IsCheck: this.order.IsCheck,
                CheckFeeType: this.order.CheckFeeType,
                CheckFee: this.order.CheckFee,
                CheckFeeVND: this.order.CheckFeeVND,
                IsFast: this.order.IsFast,
                FastFee: this.order.FastFee,
                FastFeeVND: this.order.FastFeeVND,
                Deposit: this.order.Deposit,
                DiscountVND: this.order.DiscountVND,
                GuaranteeType: this.order.GuaranteeType,
                MinDeposit: this.order.MinDeposit,
                MinDepositFixed: this.order.MinDepositFixed || 0,
                MinDepositRequest: this.order.MinDepositRequest,
                WeChatId: this.order.WeChatId,
                IsUpdateFeeShip: this.order.IsUpdateFeeShip,
                BackAmountVND: this.order.BackAmountVND,
                CostWeight: this.order.CostWeight,
                ProductType: this.order.ProductType,
                OrderType: this.order.OrderType || 'NKCN',
                Note: this.order.Note,
                CommissionFeeVND: this.order.CommissionFeeVND || 0,
                FeeUTNK: this.order.FeeUTNK || 0,
                FeeUTNKFix: this.order.FeeUTNKFix || 0,
                Surcharge1Amount: this.order.Surcharge1Amount || 0,
                Surcharge1Note: this.order.Surcharge1Note || '',
                Surcharge1CostAmount: this.order.Surcharge1CostAmount || 0,
                Surcharge2Amount: this.order.Surcharge2Amount || 0,
                Surcharge2Note: this.order.Surcharge2Note || '',
                Surcharge2CostAmount: this.order.Surcharge2CostAmount || 0,
                CostUTNK: this.order.CostUTNK || 0,
                TotalInvoicePrice: this.order.TotalInvoicePrice || 0,
                TaxOtherRate: this.order.TaxOtherRate || 0,
                TaxOtherAmount: this.order.TaxOtherAmount || 0,
                TaxOtherNote: this.order.TaxOtherNote || '',
                TaxNKRate: this.order.TaxNKRate || 0,
                TaxNKAmount: this.order.TaxNKAmount || 0,
                TaxNKNote: this.order.TaxNKNote || '',
                TaxVATRate: this.order.TaxVATRate || 0,
                TaxVATAmount: this.order.TaxVATAmount || 0,
                TaxVATNote: this.order.TaxVATNote || ''
            }            
        },
        closePanel() {
            this.$router.push({
                name: "OrderList"
            });
        },
        getUserName(id) {
            const obj = this.$store.state.commons.all_users.find(
                obj => obj.ID === id
            );
            return obj ? obj.Username : "";
        },
        getVipValue(id) {
            const item = _.find(this.vipLevels, {'ID': id});
            return item ? item.VIPName : '';
        },
        closeSnackbar() {
            Store.commit("main_order/setSnackbar", {
                snackbar: false
            });
            Store.commit("main_order/setNotice", {
                notice: ""
            });
        },
        refreshData() {
            this.orderEditable.OrderID = 0;
            this.$store.commit("main_order/setOrderDetail", {
                data: {
                    Customer: {},
                    PaymentHistory: [],
                    OrderComment: [],
                    Products: []
                }
            });
            this.$store.dispatch("commons/getAllUsers");
            this.$store.dispatch("feeGuarantee/getList");
            this.$store.dispatch("customerLevel/getCustomerLevelList");
            this.$store.dispatch("ordercn/getList", {
                filter: [{
                    column: "OrderID",
                    value: this.orderId,
                    condition: "equal"
                }]
            });
            this.$store.dispatch("main_order/getOrderDetail", {
                id: this.orderId,
                onSuccess: () => {
                    this.$store.dispatch("orderFlag/getList", {'OrderID': this.orderId, 'OrderType': configs.ORDER_TYPE.order});
                },
                onError: err => {
                    if (err && (err.status === 403 || err.status === 404)) {
                        this.$router.replace({ name: 'DataNotFound' });
                    }
                }
            });
        },
        manualUpdateDetail() {
            this.orderEditable.FeeShipCN = this.feeShipCNY;
            this.orderEditable.TotalRealAmountCNY = this.totalRealAmountCNY;
        },
        updateOrderDetail: _.debounce(function (newVal, oldVal) {
            if (this.orderReadonly) return;
            if (oldVal && oldVal.OrderID !== 0) {
                if (newVal.TotalRealAmountCNY !== 0) {
                    const rate = (newVal.ExchangeRateBuy && parseFloat(newVal.ExchangeRateBuy) > 0) ? newVal.ExchangeRateBuy : this.order.ExchangeRate;
                    newVal.TotalRealAmount = newVal.TotalRealAmountCNY * rate;
                }
                if(!_.isEqual(newVal, this.tempOrder)){
                    if(this.order.MinDeposit != this.orderEditable.MinDeposit) {
                        newVal.MinDepositFixed = 1;
                    }
                    if(this.order.FeeBuy != this.orderEditable.FeeBuy) {
                        newVal.FeeBuyFix = 1;
                    }
                    if(this.order.FeeBuyAmount != this.orderEditable.FeeBuyAmount) {
                        newVal.FeeBuy = 0;
                        newVal.FeeBuyFix = 1;
                    }
                    if(this.orderEditable.FeeBuy == 0 && this.orderEditable.FeeBuyAmount == 0) {
                        newVal.FeeBuyFix = 0;
                    }
                    if(this.order.FeeUTNK != this.orderEditable.FeeUTNK) {
                        newVal.FeeUTNKFix = 1;
                    }
                    if(this.order.FeeUTNKFix != this.orderEditable.FeeUTNKFix && !this.orderEditable.FeeUTNKFix) {
                        newVal.FeeUTNK = 0;
                    }
                    if(this.order.IsUpdateFeeShip != this.orderEditable.IsUpdateFeeShip && !this.orderEditable.IsUpdateFeeShip) {
                        newVal.IsUpdateFeeShip = 0;
                    } else if(this.order.CostWeight != this.orderEditable.CostWeight || this.order.FeeWeight != this.orderEditable.FeeWeight) {
                        newVal.IsUpdateFeeShip = 1;
                    }
                    let updateObject = {OrderID: newVal.OrderID};
                    for (const prop in newVal) {
                        if(newVal[prop] != this.order[prop]) {
                            updateObject[prop] = newVal[prop];
                        }
                    }
                    if ('XNKID' in updateObject) {
                        updateObject.OfficerID = updateObject.XNKID;
                    }
                    this.$store.dispatch("main_order/updateOrderDetail", updateObject);
                    this.tempOrder = _.cloneDeep(newVal);
                }
            }
        }, 1000),
        removeProduct(item) {
            window.getApp.$emit("REQUEST_DELETE_DATA", item, `Bạn thực sự muốn xoá sản phẩm ?`);
        },
        ReOrder() {
            if(this.order.Status == configs.ORDER_STATUS_ENUM.huy) {
                this.$store.dispatch("main_order/updateOrderDetail", {OrderID: this.order.ID, Status: configs.ORDER_STATUS_ENUM.cho_dat_coc});
            }
            else {
                sendErrorNotice("Không thể lên lại đơn hàng!");
            }
        },
        CancelOrder() {
            if(this.order.Status == configs.ORDER_STATUS_ENUM.da_dat_coc || this.order.Status == configs.ORDER_STATUS_ENUM.cho_dat_coc || this.adminRole) {
                this.$store.dispatch("main_order/updateOrderDetail", {OrderID: this.order.ID, Status: configs.ORDER_STATUS_ENUM.huy, BackAmountVND: this.backAmountVND});
                this.dialogCancelOrder = false;
            }
            else {
                sendErrorNotice("Không thể hủy đơn hàng!");
            }
        },
        WaitPayOrder() {
            if(this.order.Status == configs.ORDER_STATUS_ENUM.cho_bao_gia) {
                this.$store.dispatch("main_order/updateOrderDetail", {OrderID: this.order.ID, Status: configs.ORDER_STATUS_ENUM.cho_dat_coc});
            }
            else {
                sendErrorNotice("Không thể chuyển trạng thái đơn hàng!");
            }
        },
        DepositOrder() {
            if(this.order.Status == configs.ORDER_STATUS_ENUM.cho_dat_coc) {
                this.$store.dispatch("main_order/updateOrderDetail", {OrderID: this.order.ID, UID: this.order.UID, Status: configs.ORDER_STATUS_ENUM.da_dat_coc, Deposit: this.order.MinDeposit, ActionType: 'DepositOrder'});
            }
            else {
                sendErrorNotice("Không thể chuyển trạng thái đơn hàng!");
            }
        },
        SendAccountant() {
            if(this.order.Status == configs.ORDER_STATUS_ENUM.da_dat_coc) {
                const missingFields = [];
                const hasRealAmount = Number(this.totalRealAmountCNY || 0) > 0;
                const hasOrderCode = this.orderCodes.some(item => item && String(item.OrderCodeCN || '').trim());

                if(!hasRealAmount) {
                    missingFields.push("Tiền mua thật");
                }
                if(!hasOrderCode) {
                    missingFields.push("Mã đơn hàng");
                }
                if(missingFields.length > 0) {
                    sendErrorNotice(`Vui lòng nhập ${missingFields.join(" và ")} trước khi Chuyển Kế Toán.`);
                    return;
                }

                this.$store.dispatch("main_order/updateOrderDetail", {OrderID: this.order.ID, Status: configs.ORDER_STATUS_ENUM.cho_mua_hang});
            }
            else {
                sendErrorNotice("Không thể chuyển trạng thái đơn hàng!");
            }
        },
        WaitPayment2Order() {
            if(this.order.Status == configs.ORDER_STATUS_ENUM.cho_mua_hang) {
                this.$store.dispatch("main_order/updateOrderDetail", {OrderID: this.order.ID, Status: configs.ORDER_STATUS_ENUM.cho_tt_lan_2});
            }
            else {
                sendErrorNotice("Không thể chuyển trạng thái đơn hàng!");
            }
        },
        BuyOrder() {
            if(this.order.Status == configs.ORDER_STATUS_ENUM.cho_mua_hang || this.order.Status == configs.ORDER_STATUS_ENUM.cho_tt_lan_2) {
                this.$store.dispatch("main_order/updateOrderDetail", {OrderID: this.order.ID, Status: configs.ORDER_STATUS_ENUM.da_mua_hang});
            }
            else {
                sendErrorNotice("Không thể chuyển trạng thái đơn hàng!");
            }
        },
        SendPurchase() {
            if(this.order.Status == configs.ORDER_STATUS_ENUM.cho_mua_hang || this.order.Status == configs.ORDER_STATUS_ENUM.cho_tt_lan_2) {
                this.$store.dispatch("main_order/updateOrderDetail", {OrderID: this.order.ID, Status: configs.ORDER_STATUS_ENUM.da_dat_coc});
            }
            else {
                sendErrorNotice("Không thể chuyển trạng thái đơn hàng!");
            }
        },
        CompleteOrder() {
            if (this.orderHasPendingComplain) {
                sendErrorNotice("Đơn hàng đang có khiếu nại chưa xử lý, không thể hoàn thành!");
                return;
            }
            if (this.canCompleteOrder) {
                this.$store.dispatch("main_order/updateOrderDetail", {OrderID: this.order.ID, Status: configs.ORDER_STATUS_ENUM.hoan_thanh});
            }
            else {
                sendErrorNotice("Không thể chuyển trạng thái đơn hàng!");
            }
        },
        RevertOrder() {
            if(this.order.Status == configs.ORDER_STATUS_ENUM.hoan_thanh) {
                this.$store.dispatch("main_order/updateOrderDetail", {OrderID: this.order.ID, Status: configs.ORDER_STATUS_ENUM.da_xuat_kho});
            }
            else {
                sendErrorNotice("Không thể chuyển trạng thái đơn hàng!");
            }
        },
        openCustomerDetail: function() {
            this.showCustomerDetail = !this.showCustomerDetail;
        },
        gotoCustomerDetail: function(id) {
            let routeData = this.$router.resolve({
                name: "CustomerDetail",
                params: {
                Pid: id,
                title: `Khách hàng (#${id})`
                }
            });
            window.open(routeData.href, "_blank");
        }
    },
    mounted() {
        const normalizedTab = normalizeTab(this.$route.query.tab);
        if (normalizedTab !== this.$route.query.tab) {
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    tab: normalizedTab
                }
            }).catch(() => {});
        }
        this.$store.dispatch("productType/getList");
        this.$store.dispatch("commons/getAllStores");
        this.$store.dispatch("commons/getAllChinaStores");
        this.refreshData();
        this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
        this.$root.$on("CONFIRMED_REMOVE_DATA", item => {
            this.$store.dispatch("main_order/removeProduct", {id: item.ID, OrderID: this.orderId});
        });
    },
    beforeDestroy() {
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
    }
};
</script>

<style scoped>
.product-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.v-list--two-line .v-list__tile {
    height: auto !important;
    padding: 5px 0 5px 0;
}

.theme--light.red--text.v-input--is-disabled input {
    color: #f44336 !important;
    caret-color: #f44336 !important;
}

.image-product {
    width: 64px;
}

.theme--light.v-data-table tbody tr td .text-red,
.text-red .v-select__selection,
.text-red .v-icon.v-icon {
    color: #0088cc!important;
}
.product-highlight-row {
    background-color: bisque;
}
.cost-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
    margin-bottom: 15px;
}
.cost-table th, .cost-table td {
    border: 1px solid #e0e0e0;
    padding: 8px 12px;
    text-align: left;
    vertical-align: middle;
}
.cost-table th {
    background-color: #f5f5f5;
    font-weight: 600;
    font-size: 13px;
    color: #424242;
}
.cost-table td {
    font-size: 13px;
}
.invoice-price-row {
    background-color: #e8f5e9 !important;
    font-weight: bold;
}
.vat-rate-input >>> input {
    color: #2e7d32 !important;
    font-weight: bold;
}
.bg-light-gradient {
    background: linear-gradient(to bottom, #fcfcfc, #f8fafc) !important;
    border: 1px solid #e2e8f0 !important;
}
.border-bottom {
    border-bottom: 2px solid #1976d2;
}
.payment-summary-box {
    background-color: #fafafa;
    border: 1px solid #1976d2 !important;
}
.compact-cost-table th, .compact-cost-table td {
    padding: 6px 8px !important;
}
.border-slate-200 {
    border: 1px solid #e2e8f0 !important;
}
@media (min-width: 960px) {
    .border-right-slate {
        border-right: 1px solid #e2e8f0 !important;
    }
}
.accent-bar-blue {
    display: inline-block;
    width: 4px;
    height: 16px;
    background-color: #1976d2;
    border-radius: 4px;
}
.bg-blue-50 {
    background-color: #eff6ff !important;
}
.bg-teal-50 {
    background-color: #f0fdf4 !important;
}
.bg-violet-50 {
    background-color: #faf5ff !important;
}
.bg-amber-50 {
    background-color: #fffbeb !important;
}
.text-blue-600 {
    color: #2563eb !important;
}
.text-teal-600 {
    color: #16a34a !important;
}
.text-violet-600 {
    color: #7c3aed !important;
}
.text-amber-600 {
    color: #d97706 !important;
}
.text-slate-400 {
    color: #94a3b8 !important;
}
.text-slate-500 {
    color: #64748b !important;
}
.text-slate-700 {
    color: #334155 !important;
}
.text-slate-800 {
    color: #1e293b !important;
}
.tab-badge {
    font-size: 11px;
    font-weight: bold;
    padding: 2px 8px;
    border-radius: 9999px;
}
.overview-stack {
    display: flex;
    flex-direction: column;
    gap: 24px;
}
.overview-section {
    padding-bottom: 4px;
    border-bottom: 1px solid #eef2f7;
}
.overview-section:last-child {
    border-bottom: none;
    padding-bottom: 0;
}
.overview-section__header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
}
.overview-section__eyebrow {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #64748b;
    margin-bottom: 4px;
}
.overview-section__title {
    font-size: 22px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.2;
}
.overview-section__meta {
    color: #2563eb;
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
}
@media (max-width: 959px) {
    .overview-section__header {
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 12px;
    }
}
.gradient-balance-card {
    background: linear-gradient(135deg, #1976d2 0%, #6f00f0 100%) !important;
    position: relative;
    overflow: hidden;
    color: #ffffff;
}
.absolute-decor-icon {
    position: absolute;
    right: -10px;
    bottom: -20px;
    pointer-events: none;
}
.opacity-10 {
    opacity: 0.1 !important;
}
.opacity-20 {
    opacity: 0.2 !important;
}
.relative-content {
    position: relative;
    z-index: 2;
}
.text-blue-100 {
    color: #dbeafe !important;
}
.text-emerald-300 {
    color: #6ee7b7 !important;
}
.text-rose-300 {
    color: #fca5a5 !important;
}
.space-y-3 > * + * {
    margin-top: 12px !important;
}
.accent-bar-teal {
    display: inline-block;
    width: 4px;
    height: 16px;
    background-color: #00897b !important;
    border-radius: 4px;
}
.accent-bar-purple {
    display: inline-block;
    width: 4px;
    height: 16px;
    background-color: #7c3aed !important;
    border-radius: 4px;
}
.accent-bar-amber {
    display: inline-block;
    width: 4px;
    height: 16px;
    background-color: #d97706 !important;
    border-radius: 4px;
}
.bg-blue-gradient {
    background: linear-gradient(to bottom, #ffffff, #f0f7ff) !important;
    border: 1px solid #bfdbfe !important;
}
.bg-teal-gradient {
    background: linear-gradient(to bottom, #ffffff, #f0fdf4) !important;
    border: 1px solid #bbf7d0 !important;
}
.bg-purple-gradient {
    background: linear-gradient(to bottom, #ffffff, #faf5ff) !important;
    border: 1px solid #e9d5ff !important;
}
.bg-amber-gradient {
    background: linear-gradient(to bottom, #ffffff, #fffbeb) !important;
    border: 1px solid #fef3c7 !important;
}

.fee-list-card {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background-color: #ffffff;
    overflow: hidden;
    margin-bottom: 24px;
}
.fee-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid #f1f5f9;
}
.fee-row:last-child {
    border-bottom: none;
}
.fee-label {
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
}
.fee-subtitle {
    font-size: 12px;
    color: #64748b;
    margin-top: 2px;
}
.fee-value-input {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
.compact-input >>> input {
    font-size: 12px;
    padding: 2px 4px !important;
    height: 24px !important;
}
.compact-input >>> .v-input__slot {
    min-height: 24px !important;
}
.compact-input >>> .v-input__slot:before,
.compact-input >>> .v-input__slot:after {
    display: none !important;
}
.compact-input:not(.v-input--is-disabled):hover >>> input {
    border-bottom: 1px dashed #1976d2 !important;
}
.bg-emerald-50 {
    background-color: #ecfdf5 !important;
}
.text-emerald-600 {
    color: #059669 !important;
}
.order-short-tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
</style>
